"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirect = void 0;
var redirect = function (url) {
    location.assign(url);
    return new Promise(function () { return undefined; });
};
exports.redirect = redirect;
//# sourceMappingURL=redirect.js.map